import { ConversationSchemaDbParser } from "@redotech/redo-model/conversation/conversation-schema-db-parser";
import * as zExt from "@redotech/rpc/ext";
import { object } from "zod";

export const getConversationById = {
  name: "getConversationById" as const,
  input: object({ conversationId: zExt.objectId() }),
  output: object({ conversation: ConversationSchemaDbParser }),
};
